exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#admin_excluded_placements_page .edit-excluded-placement {\n  width: auto;\n  height: 3.4rem;\n}\n#admin_excluded_placements_page .cancel-editing {\n  padding: 0.8rem 1.65rem;\n}\n#admin_excluded_placements_page input[type=radio] {\n  position: relative;\n  top: 0.1rem;\n}\n#admin_excluded_placements_page .VueTables__search {\n  display: none;\n}\n#admin_excluded_placements_page .VueTables__table {\n  table-layout: fixed;\n}", ""]);

// exports
